import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  .headder-container {
    width: 90%;
    margin: auto;
    .headder-options-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 2rem 0;
      flex-wrap: wrap;
    }
    .headder-teams-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .option-content {
        width: 40%;
      }
    }
    .option-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 50%;
      label {
        color: #6f7a80;
        font-weight: 700;
      }
      select {
        margin: 1rem 0;
        border: 1px solid #ccc;
        width: 90%;
        color: #333;
        font-size: 1em;
        height: 36px;
        -webkit-appearance: none;
        border-radius: 1.5rem;
      }
    }
  }
  .pagination {
    display: flex;
    width: 90%;
    margin: 1rem auto;
    justify-content: flex-start;
    align-items: center;
    padding: 0;
    li {
      list-style: none;
      .page-link {
        padding: 0.5rem 0.75rem;
        color: #000;
        background: #ebe9e7;
        border: none;
        height: 100%;
        cursor: pointer;
        &.left {
          border-radius: 24px 0 0 24px;
        }
        &.right {
          border-radius: 0 24px 24px 0;
        }
        &:hover {
          background: #e5e7eb;
        }
      }
      &.total-pages-number {
        margin: 0 1rem;
      }
    }
    select {
      padding: 0.5rem 0.75rem;
      color: #000;
      border: none;
      background: #ebe9e7;
    }
  }

  .table-scrollable {
    overflow-x: auto;
    padding-bottom: 1rem;
    position: relative;
    width: 90%;
    margin: 1rem auto;
    table {
      width: 90%;
      margin: 1rem auto;
      border: none;
      border-collapse: collapse;
      opacity: 1;
      &.loading {
        opacity: 0.5;
      }
      thead tr {
        display: flex;
        justify-content: space-between;
        text-align: left;
        th {
          font-size: 10px;
          font-weight: 700;
          white-space: nowrap;
          min-width: 30px;
          margin: 0.5rem;
          cursor: pointer;
          &:nth-child(1) {
            cursor: unset;
          }
          &:nth-child(2) {
            cursor: unset;
          }
          &.lineup-title {
            width: calc(150px - 1rem);
            position: sticky;
            display: inline-table;
            left: 0;
            background-color: white;
            z-index: 1;
            white-space: unset;
          }
          &.up-arrow {
            display: flex;
            align-items: center;
            &::after {
              content: "";
              width: 0;
              height: 0;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              border-bottom: 7px solid green;
            }
          }
          &.down-arrow {
            display: flex;
            align-items: center;
            &::after {
              content: "";
              width: 0;
              height: 0;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              border-top: 7px solid #f00;
            }
          }
        }
      }
      tbody tr {
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        text-align: left;
        &:hover {
          background: lightGray;
          td.lineup {
            background: lightGray;
          }
        }
        td {
          font-size: 10px;
          white-space: nowrap;
          min-width: 30px;
          margin: 0.5rem;
          &.lineup {
            width: calc(150px - 1rem);
            display: inline-table;
            position: sticky;
            left: 0;
            background-color: white;
            z-index: 1;
            white-space: unset;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 867px) {
    .headder-container .option-content {
      width: 20%;
      select {
        width: 70%;
      }
    }
    .pagination {
      justify-content: flex-end;
    }

    .table-scrollable {
      width: 100%;
      overflow-x: unset;
      table {
        width: 95%;
        tbody tr td.lineup,
        thead tr th.lineup-title {
          width: calc(200px - 1rem);
          min-width: calc(200px - 1rem);
        }
        thead tr th,
        tbody tr td {
          font-size: 13px;
          min-width: 3%;
          margin: 1rem 0;
          padding: 1rem 0;
        }
      }
    }
  }
`;
